/* Luk alle facet-grupper (details) fra start – undtagen den første.
   Grupper med aktive valg forbliver åbne.
   Virker i OS 2.0-temaer (Search & Discovery). */

(function () {
  // Ændr evt. til en bestemt overskrift, fx 'Lys'. Tom streng = brug 1. gruppe.
  const PREFER_HEADING_TEXT = ''; // fx 'Lys'

  const norm = (s) => (s || '').trim().toLowerCase();

  function findFacetRoot() {
    // Prøv flere kendte containere for forskellige temaer
    return (
      document.querySelector('facet-filters-form') ||
      document.querySelector('#FacetFiltersForm') ||
      document.querySelector('.facets-vertical') ||
      document.querySelector('.collection-filters') ||
      document.querySelector('.facets') ||
      null
    );
  }

  function hasActiveSelection(detailsEl) {
    // Checkbox/radio/selected option, eller aktive chips hvis temaet viser dem inde i gruppen
    return !!detailsEl.querySelector(
      'input[type="checkbox"]:checked, input[type="radio"]:checked, select option:checked:not([value=""]), .active-facet, [data-active="true"]'
    );
  }

  function openDetails(d)  { if (d && !d.hasAttribute('open')) d.setAttribute('open', ''); }
  function closeDetails(d) { if (d && d.hasAttribute('open')) d.removeAttribute('open'); }

  function foldOnce(root) {
    if (!root) return;
    const groups = Array.from(root.querySelectorAll('details'));
    if (!groups.length) return;

    // Luk alle uden aktive valg, åbn dem med aktive valg
    let anyActive = false;
    groups.forEach((d) => {
      if (hasActiveSelection(d)) { openDetails(d); anyActive = true; }
      else { closeDetails(d); }
    });

    // Hvis ingen er aktive, åbn kun én (første – eller match på overskriftstekst)
    if (!anyActive) {
      let target = groups[0];
      if (PREFER_HEADING_TEXT) {
        const wanted = groups.find((d) =>
          norm(d.querySelector('summary')?.textContent).includes(norm(PREFER_HEADING_TEXT))
        );
        if (wanted) target = wanted;
      }
      openDetails(target);
    }
  }

  function apply() {
    const root = findFacetRoot();
    if (!root) return;
    // Kør på næste frame for at undgå at "slås" med temaets egen init
    requestAnimationFrame(() => foldOnce(root));
  }

  // Første indlæsning
  document.addEventListener('DOMContentLoaded', apply);

  // Kør når sektioner re-rendres (Shopify-sektionshændelse)
  document.addEventListener('shopify:section:load', apply);

  // Nogle temaer skyder custom events efter AJAX-filtrering
  document.addEventListener('facets:updated', apply);

  // Faldback: observer DOM-udskiftning i facet-området og kør igen
  const onReady = () => {
    const root = findFacetRoot();
    if (!root) return;
    const mo = new MutationObserver(() => apply());
    mo.observe(root, { childList: true, subtree: true });
  };
  document.addEventListener('DOMContentLoaded', onReady);
})();
